import {get,post} from '../utils/request';
// 获取七牛云上传凭证
export const getUploadToken = params => post('/qiniu/getUploadToken',params);